<template>
  <div class="action flex-grow-0 flex-shrink-0 col" :class="{ completed : completed || edit }">
    <div v-if="edit" class="tag">Edit</div>
    <div v-else class="tag">{{ completed ? completedLabel : todoLabel }}</div>
  </div>
</template>

<script>
export default {
  props: {
    completed: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    completedLabel: {
      type: String,
      default: 'Done',
    },
    todoLabel: {
      type: String,
      default: 'Action',
    },
  },
};
</script>
